export const modules = [
  {
    id: 1,
    title: 'Dashboard General',
    description: 'Panel principal con resumen completo de afiliados, deudas, cortes, finanzas y lecturas pendientes en tiempo real.',
    image: 'https://storage.helloreaddy.io/project_files/6cdd528b-b3f6-427c-a8db-1dc5e6497a05/c44949ab-f1c0-44dc-ac47-a98326f8464c_compressed_Screenshot-2026-07-25-142723.webp',
    category: 'Administración',
  },
  {
    id: 2,
    title: 'Gestión de Afiliados',
    description: 'Base completa de clientes con estados de conexión, medidores, ramales, deudas históricas y ubicación geográfica.',
    image: 'https://storage.helloreaddy.io/project_files/6cdd528b-b3f6-427c-a8db-1dc5e6497a05/ed5aab1b-c669-46ae-a985-137d91bc5083_compressed_Screenshot-2026-07-25-142737.webp',
    category: 'Administración',
  },
  {
    id: 3,
    title: 'Mapa y Ubicaciones',
    description: 'Visualización geográfica de conexiones, rutas y ramales con OpenStreetMap. Gestión de zonas y trazado de tuberías.',
    image: 'https://storage.helloreaddy.io/project_files/6cdd528b-b3f6-427c-a8db-1dc5e6497a05/2396d6b5-4407-4c1d-b047-00a5c7e2c197_compressed_Screenshot-2026-07-25-142750.webp',
    category: 'Operación',
  },
  {
    id: 4,
    title: 'Registro de Lecturas',
    description: 'Registro masivo mensual de lecturas de medidores con cálculo automático de consumo y comparativa con períodos anteriores.',
    image: 'https://storage.helloreaddy.io/project_files/6cdd528b-b3f6-427c-a8db-1dc5e6497a05/1dcf8230-0860-4c43-bd0c-e81abd2885f1_compressed_Screenshot-2026-07-25-142822.webp',
    category: 'Operación',
  },
  {
    id: 5,
    title: 'Revisión con Foto',
    description: 'Verificación de lecturas con fotografía del medidor, comparativa histórica y validación de consumo anómalo.',
    image: 'https://storage.helloreaddy.io/project_files/6cdd528b-b3f6-427c-a8db-1dc5e6497a05/fe4898dd-cba3-445e-9bad-cb8d01ab6652_compressed_Screenshot-2026-07-25-102715.webp',
    category: 'Operación',
  },
  {
    id: 6,
    title: 'Caja y Cobros',
    description: 'Cobros de mes de agua con historial completo de deudas, estados de cuenta y detalle de pagos por período.',
    image: 'https://storage.helloreaddy.io/project_files/6cdd528b-b3f6-427c-a8db-1dc5e6497a05/9294790a-8c70-495f-831d-4047a23b2b14_compressed_Screenshot-2026-07-25-142839.webp',
    category: 'Finanzas',
  },
  {
    id: 7,
    title: 'Administración de Cortes',
    description: 'Control de cortes y reconexiones de servicio con generación automática de boletas de orden de corte.',
    image: 'https://storage.helloreaddy.io/project_files/6cdd528b-b3f6-427c-a8db-1dc5e6497a05/2ee7c3d0-be40-4574-9b8f-516ca307c6c2_compressed_Screenshot-2026-07-25-142852.webp',
    category: 'Operación',
  },
  {
    id: 8,
    title: 'Recibos con QR',
    description: 'Emisión de recibos oficiales de consumo con gráficos de uso, código QR de verificación y respaldo de pago.',
    image: 'https://storage.helloreaddy.io/project_files/6cdd528b-b3f6-427c-a8db-1dc5e6497a05/657c9834-f17f-41b6-af73-3e1c5f083b1a_compressed_Screenshot-2026-07-25-142935.webp',
    category: 'Finanzas',
  },
  {
    id: 9,
    title: 'Finanzas y Movimientos',
    description: 'Control detallado de ingresos, egresos y balance general por período gestionado, con listado completo de transacciones.',
    image: 'https://storage.helloreaddy.io/project_files/6cdd528b-b3f6-427c-a8db-1dc5e6497a05/f5a728dd-978d-4475-a2ec-2655e57a2313_compressed_Screenshot-2026-07-25-143002.webp',
    category: 'Finanzas',
  },
  {
    id: 10,
    title: 'Tarifas Configurables',
    description: 'Configuración de tarifas por categorías A, B y C con límites personalizables, multas automáticas e histórico de vigencias.',
    image: 'https://storage.helloreaddy.io/project_files/6cdd528b-b3f6-427c-a8db-1dc5e6497a05/d39ddf44-e5c4-44bd-8e63-31807023d50a_compressed_Screenshot-2026-07-25-143014.webp',
    category: 'Configuración',
  },
  {
    id: 11,
    title: 'Auditoría de Sistema',
    description: 'Registro completo de cada acción realizada en el sistema: usuario, fecha, acción y detalle de modificación.',
    image: 'https://storage.helloreaddy.io/project_files/6cdd528b-b3f6-427c-a8db-1dc5e6497a05/38abed66-45ed-45c0-a3c3-6e148832376c_compressed_Screenshot-2026-07-25-143035.webp',
    category: 'Seguridad',
  },
  {
    id: 12,
    title: 'Sincronización Online',
    description: 'Publicación al servidor para habilitar el portal web de afiliados y la app móvil de lecturación con acceso remoto.',
    image: 'https://storage.helloreaddy.io/project_files/6cdd528b-b3f6-427c-a8db-1dc5e6497a05/617c1929-7a70-450a-b384-28397667e5e4_compressed_Screenshot-2026-07-25-143052.webp',
    category: 'Online',
  },
];